import { useEffect, useRef } from "react";

const ExteriorParallax = ({ imgArr }) => {
  const extRef = useRef(null);
  const lastScrollTimeRef = useRef(0);

  useEffect(() => {
    const canvas = document.getElementById("exterior-parallax");
    const context = canvas.getContext("2d");

    const frameCount = imgArr?.length;

    const img = new Image();
    img.src = imgArr[0];

    const draw = () => {
      // resize the canvas to match its visible size
      canvas.width = canvas.clientWidth;
      canvas.height = canvas.clientHeight;

      const loaded = img;
      const iw = loaded.width;
      const ih = loaded.height;
      const cw = canvas.width;
      const ch = canvas.height;
      const f = Math.min(cw / iw, ch / ih);

      context.setTransform(
        /*     scale x */ f,
        /*      skew x */ 0,
        /*      skew y */ 0,
        /*     scale y */ f,
        /* translate x */ (cw - f * iw) / 2,
        /* translate y */ (ch - f * ih) / 2
      );

      context.drawImage(loaded, 0, 0);
    };

    const updateImage = (index) => {
      img.src = imgArr[Math.ceil(index)];
      img.onload = function () {
        draw();
      };
    };

    const handleScroll = () => {
      const currentTime = performance.now();
      if (currentTime - lastScrollTimeRef.current < 20) {
        return; // Debounce scroll events
      }
      lastScrollTimeRef.current = currentTime;

      const containerBoundingClientRect =
        extRef.current.parentNode.getBoundingClientRect();
      const scrollPercent =
        -containerBoundingClientRect.top /
        (containerBoundingClientRect.height - window.innerHeight);

      const targetTime =
        Math.max(Math.min(scrollPercent, 1), 0) * (frameCount + 35);

      requestAnimationFrame(() => updateImage(targetTime + 1));
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [imgArr]); // Watch for changes in imgArr

  return (
    <div style={{ height: "800vh", position: "relative" }} ref={extRef}>
      <div className="top-[30px] mx-auto sticky h-screen w-full">
        <canvas
          className="w-[100%] absolute top-[50%] left-[50%] h-[100%]"
          style={{ transform: "translate(-50%, -50%)" }}
          height={1080}
          width={1920}
          id="exterior-parallax"
        />
      </div>
    </div>
  );
};

export default ExteriorParallax;
